"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginStatus = void 0;
var LoginStatus;
(function (LoginStatus) {
    /** The person is logged into Facebook, and has logged into your webpage. */
    LoginStatus["Connected"] = "connected";
    /** The person is logged into Facebook, but has not logged into your webpage. */
    LoginStatus["NotAuthorized"] = "not_authorized";
    /** The person is not logged into Facebook, so you don't know if they have logged into your webpage. Or FB.logout() was called before, and therefore, it cannot connect to Facebook. */
    LoginStatus["Unknown"] = "unknown";
})(LoginStatus || (exports.LoginStatus = LoginStatus = {}));
